import { v4 as uuidv4 } from "uuid";
import checkBulletImage from "@circle-react-shared/BuilderUI/Assets/icons/check_bullet_transparent.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { bulletStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/UlListBlock/UlBlockDefaultData";
import { createPlanCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/Pricing/PlanCard/PlanCardBlockDefaultData";
import { getBlockSecondaryStyleOptions } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import {
  createH2Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getTextTransformOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "EvergreenHomepageBlock9",
  props: {
    leftContent: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Feature section",
          paragraphStyle: "p3",
          styles: {
            textTransform: getTextTransformOptions("uppercase"),
          },
        }),
        createH2Block({
          text: "Go from uncertainty to a scalable course with structure",
        }),
        createPBlock({
          text: "This course gives you the tools, mindset, and roadmap to:",
        }),
        createUlBlock({
          items: [
            {
              text: "Define and refine your niche and signature offer",
              placeholder: checkBulletImage,
              bulletStyles,
            },
            {
              text: "Launch a program that aligns with your goals and audience",
              placeholder: checkBulletImage,
              bulletStyles,
            },
            {
              text: "Set up sustainable systems to run your course smoothly",
              placeholder: checkBulletImage,
              bulletStyles,
            },
          ],
        }),
      ],
    },
    rightContent: {
      prop: "children",
      type: "children",
      value: [
        createPlanCardBlock({
          title: "All Access Plan",
          price: "$89",
          priceSuffix: "/month",
          button: {
            text: "Get access",
            href: "#",
          },
          listTitle: "What’s included:",
          features: [
            "5 Core modules",
            "10+ Video lessons",
            "Notion worksheet templates",
            "Private community access",
            "Monthly live Q&A sessions",
          ],
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockSecondaryStyleOptions(),
      },
    },
  },
};
